import JobForm from "src/components/forms/Job.form";
import { useNavigate } from "react-router-dom";
import JobOffer from "src/types/JobOffer.type";
import useApi from "src/hooks/useApi";
import CONFIG_KEYS from "src/constants/config.const";
import usePageView from "../../../hooks/usePageView";
import TrackingSystem from "../../../lib/Tracking/TrackingSystem";

export default function AddJob() {
  const navigate = useNavigate();
  const API = useApi();

  usePageView("form_job");
  const onSubmit = async (values: Partial<JobOffer>) => {
    const res = await API.POST(`res/job`, values);
    if (res?.success) {

      let ts = TrackingSystem.getInstance().sendCustomEvent("job_added");
      navigate("/app/section/jobs");
    }
  };

  return (
    <JobForm
      title="create_job_offer"
      onSubmit={onSubmit}
      costId={CONFIG_KEYS.ADD_JOBOFFER_COST}
      expiryId={CONFIG_KEYS.JOBOFFER_EXPIRY_PERIOD}
    />
  );
}
